<template>
  <modal
    name="generical-modal"
    :width="'188px'"
    :height="'auto'"
    styles="border-radius: 10px;"
  >
    <div class="accept-title">
      <div class="check--icon">
          <CheckIcon size="32" color="#FFFFFF" />
        </div>
        <p class="text">{{ loadingText }}</p>
    </div>
  </modal>
</template>

<script>
import { CheckIcon } from '@vue-hero-icons/outline';

export default {
  components: {
    CheckIcon,
  },
  props: {
    loadingText: {
      type: String,
      default: 'Sucesso!',
    },
  },
};
</script>

<style scoped>
.generic-modal {
  background: #000000;
  opacity: 0.5;
  height: 100%;
}

.check--icon {
  background: #36A3CA;
  color: #fafafa;
  height: 32px;
  border-radius: 50%;
  padding: 6px;
  margin-top: 24px;
}

.accept-title {
  width: 188px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.text {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  padding-bottom: 24px;
}

.border-modal {
  border-radius: 20px !important;
}
</style>
